import React from "react";
import { Button, Form } from "semantic-ui-react";
import { Props, registrationType } from "../propTypes";
import ECForm from "../forms/ECForm";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faBook, faClock } from "@fortawesome/pro-light-svg-icons";

import {
    ObjectLiteral,
    getRandomNumberBasedLeadersNames,
} from "../../constants";
import { eGroupLeader } from "../../store/egroups/types";
import { connect } from "react-redux";
import withRouter from "next/dist/client/with-router";
import { mapDispatchToProps, mapStateToProps } from "../../store/mapProps";
import { ProgressIndicator } from "../forms/ProgressIndicator";
import Image from "next/image";
import { shimmer, toBase64 } from "src/js/constants";

// Join a Group Component
/**
 * We are using this component for the complete sign up process once a user selects an
 * eGroup to join. The ECForm component renders the form, while the renderConfirmation() &
 * renderSuccess() functions display the content to the respective props on the form.
 *
 * We are using the Form and Button components from Semantic UI React Library.
 * For more information on these components can be found at https://react.semantic-ui.com/collections/form/
 * and https://react.semantic-ui.com/elements/button/
 */

class Join extends React.Component<Props, any> {
    divElement = React.createRef<HTMLDivElement>();

    state = {
        showError404: false,
        eGroupData: null,
        cancelUrl: "",
        valid: false,
        showValidation: false,
        validationText: "",
    };

    // Component Did Mount Lifecycle Method
    /**
     * componentDidMount() runs immediately after the component mounts.
     *
     * Here, we are checking if we have the eGroups ID as a url parameter.
     */
    componentDidMount() {
        if (this.props.router?.query.egroupid) {
            if (
                !(
                    this.props.eGroups &&
                    this.props.eGroups.eGroupData &&
                    this.props.eGroups.eGroupData.id ===
                        this.props.router?.query.egroupid
                )
            ) {
                this.props.actions.eGroups.egroups_get_egroup(
                    this.props.router?.query.egroupid as string
                );
            }
        }
    }

    // Component Did Update Lifecycle Method
    /**
     * componentDidUpdate() runs immediately after the component updates.
     * This method does not run during the initial render.
     */
    componentDidUpdate() {
        if (
            this.state.valid &&
            this.props.eGroups.joineGroupResponseError &&
            this.props.eGroups.joineGroupResponseError.status_code &&
            this.props.eGroups.joineGroupResponseError.status_code !== 200
        ) {
            let errorText = "Error confirming code. Please try again later.";

            if (
                this.props.eGroups.joineGroupResponseError.message &&
                _.isString(this.props.eGroups.joineGroupResponseError.message)
            ) {
                errorText = this.props.eGroups.joineGroupResponseError.message;
            }

            this.setState({
                valid: false,
                showValidation: true,
                validationText: errorText,
            });
        }

        if (
            this.props.eGroups.eGroupData &&
            !_.isEmpty(this.props.eGroups.eGroupData) &&
            !_.isEqual(this.props.eGroups.eGroupData, this.state.eGroupData)
        ) {
            let error404 = false;

            if (
                this.props.eGroups.eGroupData &&
                !_.isObject(this.props.eGroups.eGroupData)
            ) {
                error404 = true;
            }

            this.setState({
                eGroupData: this.props.eGroups.eGroupData,
                showError404: error404,
                cancelUrl: `/egroups/show/${this.props.eGroups.eGroupData.id}`,
            });
        }
    }

    // Cancel Function
    /**
     * onCancel() this is the callback after a user clicks on the cancel button. In this scenario it redirects the
     * user to the eTeams home
     */
    // onCancel = (e: any) => {
    //     e.preventDefault();
    //     this.props.history.push(this.state.cancelUrl);
    // };

    onCancel = (e: any) => {
        e.preventDefault();
        this.props.router.push({
            pathname: this.state.cancelUrl,
        });
    };

    // Render Confirmation Function
    /**
     * renderConfirmation() Renders the view to show the action confirmation (in this case register for a eGroups).
     * This function is required by the Form component.
     */
    renderConfirmation = (
        data: ObjectLiteral,
        nextStepAction: any,
        currentUserExtraData: ObjectLiteral
    ) => {
        const { firstName } = data;

        return (
            <div className="col-xs-12 max-w-500 full-width center-content m-b-spacer-3xl">
                <h2 className="text-dark text-left no-bottom-margin m-b-spacer-md font-size-24 text-center">
                    {firstName}, ready to join this eGroup?
                </h2>
                <Form>
                    <div className="background-off-white ec-border-radius-sm p-spacer-lg">
                        <div className="egroup-leader-imgs p-b-spacer-sm flex rel-pos">
                            {this.props.eGroups.eGroupData &&
                                !_.isEmpty(
                                    this.props.eGroups.eGroupData.leaders
                                ) &&
                                this.props.eGroups.eGroupData.leaders.map(
                                    (item: eGroupLeader, key: number) => {
                                        if (item && item && item.profileImage) {
                                            return (
                                                <div
                                                    key={key}
                                                    className="ec-box-shadow leader-avatar avatar b-x-width-md b-y-width-md border-white ec-rounded medium-img no-overflow rel-pos egroup-leader-img-ontop"
                                                >
                                                    <Image
                                                        layout="fill"
                                                        sizes="90px"
                                                        objectFit={"cover"}
                                                        objectPosition={"top"}
                                                        src={item.profileImage}
                                                        alt="Leader Image"
                                                        placeholder="blur"
                                                        blurDataURL={`data:image/svg+xml;base64,${toBase64(
                                                            shimmer(72, 72)
                                                        )}`}
                                                    />
                                                </div>
                                            );
                                        } else {
                                            const leaderNameSplit =
                                                item.name.split(" ");
                                            const leaderInitials = `${leaderNameSplit[0][0]} ${leaderNameSplit[1][0]}`;
                                            let gradientNumber =
                                                getRandomNumberBasedLeadersNames(
                                                    leaderInitials,
                                                    1,
                                                    7
                                                );

                                            if (key < 4) {
                                                return (
                                                    <div
                                                        key={key}
                                                        className="ec-box-shadow b-x-width-md b-y-width-md border-white ec-rounded medium-img no-overflow rel-pos egroup-leader-img-ontop"
                                                    >
                                                        <div
                                                            className={`egroups-leader-no-image rel-pos full-height full-width gradient${gradientNumber}`}
                                                        >
                                                            <div className="text-center full-width abs-pos absolute-center text-white icon-xxl font-size-30">
                                                                {leaderInitials}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            } else {
                                                return null;
                                            }
                                        }
                                    }
                                )}
                        </div>

                        <h3 className="text-dark text-left sec-font m-t-spacer-sm m-b-spacer-md font-size-18">
                            {this.props.eGroups.eGroupData
                                ? this.props.eGroups.eGroupData.name
                                : ""}
                        </h3>
                        <p>
                            <small>
                                <FontAwesomeIcon icon={faUser} />{" "}
                                {this.props.eGroups.eGroupData
                                    ? this.props.eGroups.eGroupData.demographic
                                    : ""}
                            </small>
                        </p>
                        <p>
                            <small>
                                <FontAwesomeIcon icon={faBook} />{" "}
                                {this.props.eGroups.eGroupData
                                    ? this.props.eGroups.eGroupData.egroupType
                                    : ""}
                            </small>
                        </p>
                        <p>
                            <small>
                                <FontAwesomeIcon icon={faClock} />{" "}
                                {this.props.eGroups.eGroupData
                                    ? this.props.eGroups.eGroupData.schedule
                                    : ""}{" "}
                                {`${
                                    this.props.eGroups.eGroupData &&
                                    this.props.eGroups.eGroupData.dayOfWeek
                                        ? ", "
                                        : ""
                                }${
                                    this.props.eGroups.eGroupData
                                        ? this.props.eGroups.eGroupData
                                              .dayOfWeek
                                        : ""
                                }${
                                    this.props.eGroups.eGroupData &&
                                    this.props.eGroups.eGroupData.time
                                        ? " at "
                                        : ""
                                }${
                                    this.props.eGroups.eGroupData
                                        ? this.props.eGroups.eGroupData.time
                                        : ""
                                }`}
                            </small>
                        </p>
                    </div>
                    {this.props.eGroups.isLoading ||
                    this.props.main.isLoading ? (
                        <div className="form-loading rel-pos  m-t-spacer-md  way-forward full-width uptop">
                            <div className="la-ball-clip-rotate la-color la-md loading-spin abs-pos absolute-center">
                                <div />
                            </div>
                        </div>
                    ) : (
                        <Button
                            id={`cc-egroups-${this.props.router?.query.egroupid}-join`}
                            className="m-t-spacer-lg full-width no-border text-white  p-y-spacer-md uppercase let-sp-reg hover-grow ec-border-radius"
                            disabled={
                                this.props.eGroups.isLoading ||
                                this.props.main.isLoading
                            }
                            onClick={() => {
                                if (
                                    this.props.eGroups.eGroupData &&
                                    this.props.main.userData
                                ) {
                                    this.setState({
                                        valid: true,
                                        showValidation: false,
                                    });

                                    this.props.actions.eGroups.egroups_join_egroup(
                                        {
                                            eGroupId:
                                                this.props.eGroups.eGroupData
                                                    .id,
                                            userId: this.props.main.userData
                                                .contactId,
                                            userExtraData: currentUserExtraData,
                                            callback: nextStepAction,
                                        }
                                    );
                                }
                            }}
                        >
                            Join Group
                        </Button>
                    )}
                    {!this.props.eGroups.isLoading &&
                    !this.props.main.isLoading ? (
                        <Button
                            id={`cc-egroups-${this.props.router?.query.egroupid}-join-cancel`}
                            className="full-width ec-no-background no-border text-alt-dark-grey m-t-spacer-xs no-outline uppercase let-sp-reg hover-grow ec-border-radius"
                            onClick={this.onCancel}
                        >
                            Cancel
                        </Button>
                    ) : null}

                    {this.state.showValidation ? (
                        <div className="ec-error">
                            <small className="ec-primary-font ec-line-height">
                                {this.state.validationText}
                            </small>
                        </div>
                    ) : null}
                </Form>
                <div className="m-t-spacer-lg">
                    <ProgressIndicator
                        percentage={100}
                        currentStep={data.step}
                    />
                </div>
            </div>
        );
    };

    // Render Success Function
    /**
     * renderSuccess() Renders the view to show after the user has completed the process of signup for an eGroup.
     * This function is required by the Form component.
     */
    redirectToSuccessView = () => {
        this.props.router?.push({
            pathname: this.props.router.pathname + "/success",
            query: this.props.router?.query,
        });

        return (
            <div className="form-loading rel-pos  m-t-spacer-md  way-forward full-width uptop">
                <div className="la-ball-clip-rotate la-color la-md loading-spin abs-pos absolute-center">
                    <div />
                </div>
            </div>
        );
    };

    render() {
        if (!this.props.eGroups.eGroupData && this.props.eGroups.isLoading) {
            return null;
        }

        return (
            <ECForm
                {...this.props}
                renderConfirmation={this.renderConfirmation}
                showError404={
                    this.state.showError404 ||
                    (!this.props.eGroups.eGroupData &&
                        !this.props.eGroups.isLoading)
                }
                isLoading={
                    this.props.eGroups.isLoading || this.props.main.isLoading
                }
                renderSuccess={this.redirectToSuccessView}
                cancelUrl={this.state.cancelUrl}
                registrationType={registrationType.eGroup || null}
                allowContactToUpdateSalesForceInfo={false}
                tagPrefixId={`cc-egroups-${this.props.router?.query.egroupid}`}
            />
        );
    }
}

// export default Join;
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Join));
